import { create } from 'zustand'

export interface ThemeConfig {
  key: string
  name: string
  colors: {
    primary: string
    primaryLight: string
    primaryDark: string
    gradient: string
  }
}

/** 预置主题 */
export const themes: ThemeConfig[] = [
  {
    key: 'aurora-sage',
    name: '鼠尾草绿',
    colors: { primary: '#5a8d6e', primaryLight: '#81b29a', primaryDark: '#3d5c4a', gradient: '135deg, #3d5c4a 0%, #5a8d6e 40%, #81b29a 100%' },
  },
  {
    key: 'mars-green',
    name: '马尔斯绿',
    colors: { primary: '#008F8D', primaryLight: '#14B8A6', primaryDark: '#00605E', gradient: '135deg, #00605E 0%, #008F8D 40%, #14B8A6 100%' },
  },
  {
    key: 'rose-pink',
    name: '玫瑰粉',
    colors: { primary: '#E8A0BC', primaryLight: '#F9D2E4', primaryDark: '#D4809A', gradient: '135deg, #D4809A 0%, #E8A0BC 40%, #F9D2E4 100%' },
  },
  {
    key: 'taro-purple',
    name: '香芋紫',
    colors: { primary: '#C98EFF', primaryLight: '#D9B3FF', primaryDark: '#B06EE6', gradient: '135deg, #B06EE6 0%, #C98EFF 40%, #D9B3FF 100%' },
  },
  {
    key: 'apple-green',
    name: '苹果青',
    colors: { primary: '#73AE52', primaryLight: '#8CC46E', primaryDark: '#5C8C3E', gradient: '135deg, #5C8C3E 0%, #73AE52 40%, #8CC46E 100%' },
  },
  {
    key: 'cheese',
    name: '奶酪',
    colors: { primary: '#FBF1D7', primaryLight: '#FFFFFF', primaryDark: '#D4C590', gradient: '135deg, #D4C590 0%, #FBF1D7 40%, #FFFFFF 100%' },
  },
  {
    key: 'lotus-cyan',
    name: '荷青',
    colors: { primary: '#A1E6DD', primaryLight: '#B8ECF0', primaryDark: '#6CC9C0', gradient: '135deg, #6CC9C0 0%, #A1E6DD 40%, #B8ECF0 100%' },
  },
  {
    key: 'starlight-blue',
    name: '星光蓝',
    colors: { primary: '#41BBC8', primaryLight: '#6FD1DB', primaryDark: '#2E9AA6', gradient: '135deg, #2E9AA6 0%, #41BBC8 40%, #6FD1DB 100%' },
  },
  {
    key: 'mint-green',
    name: '艾绿',
    colors: { primary: '#A4E2C6', primaryLight: '#BFEDDA', primaryDark: '#7BC7A3', gradient: '135deg, #7BC7A3 0%, #A4E2C6 40%, #BFEDDA 100%' },
  },
  {
    key: 'cherry-blossom',
    name: '樱花粉',
    colors: { primary: '#FFB7C5', primaryLight: '#FFD1DA', primaryDark: '#E898AC', gradient: '135deg, #E898AC 0%, #FFB7C5 40%, #FFD1DA 100%' },
  },
  {
    key: 'light-cyan',
    name: '浅青',
    colors: {
      primary: '#9ADADA',
      primaryLight: '#FFF5E6',
      primaryDark: '#5A9EA6',
      gradient: '135deg, #6FB4BC 0%, #9ADADA 40%, #FFF0DE 100%',
    },
  },
  {
    key: 'purple-blue',
    name: '紫幽蓝',
    colors: { primary: '#707899', primaryLight: '#8E94A8', primaryDark: '#55607A', gradient: '135deg, #55607A 0%, #707899 40%, #8E94A8 100%' },
  },
  {
    key: 'bamboo-moon',
    name: '竹月色',
    colors: { primary: '#6090B8', primaryLight: '#8AABD0', primaryDark: '#46729A', gradient: '135deg, #46729A 0%, #6090B8 40%, #8AABD0 100%' },
  },
  {
    key: 'light-fragrance',
    name: '薄香',
    colors: { primary: '#DBC6B4', primaryLight: '#EDE0D6', primaryDark: '#C4AE9B', gradient: '135deg, #C4AE9B 0%, #DBC6B4 40%, #EDE0D6 100%' },
  },
  {
    key: 'pine-cone-brown',
    name: '松果褐',
    colors: { primary: '#664B3A', primaryLight: '#8B6F5E', primaryDark: '#4A3528', gradient: '135deg, #4A3528 0%, #664B3A 40%, #8B6F5E 100%' },
  },
  {
    key: 'fog-purple-gray',
    name: '雾感紫灰',
    colors: { primary: '#8A7E97', primaryLight: '#A69DB2', primaryDark: '#706585', gradient: '135deg, #706585 0%, #8A7E97 40%, #A69DB2 100%' },
  },
  {
    key: 'star-purple',
    name: '星紫',
    colors: { primary: '#A855F7', primaryLight: '#C084FC', primaryDark: '#7E22CE', gradient: '135deg, #7E22CE 0%, #A855F7 40%, #C084FC 100%' },
  },
  {
    key: 'ginger-yellow',
    name: '姜黄',
    colors: { primary: '#FBBF24', primaryLight: '#FCD34D', primaryDark: '#D99E0A', gradient: '135deg, #D99E0A 0%, #FBBF24 40%, #FCD34D 100%' },
  },
  {
    key: 'moss-green',
    name: '苔绿',
    colors: { primary: '#10B981', primaryLight: '#34D399', primaryDark: '#059669', gradient: '135deg, #059669 0%, #10B981 40%, #34D399 100%' },
  },
  {
    key: 'peach-pink',
    name: '桃粉',
    colors: { primary: '#FBCFE8', primaryLight: '#FDE2EF', primaryDark: '#F0A0C8', gradient: '135deg, #F0A0C8 0%, #FBCFE8 40%, #FDE2EF 100%' },
  },
  {
    key: 'haze-blue',
    name: '雾霾蓝',
    colors: { primary: '#6B88B0', primaryLight: '#8AA4C8', primaryDark: '#526E96', gradient: '135deg, #526E96 0%, #6B88B0 40%, #8AA4C8 100%' },
  },
  {
    key: 'ou-green',
    name: '欧碧',
    colors: { primary: '#C0D392', primaryLight: '#D8E2B8', primaryDark: '#9FB578', gradient: '135deg, #9FB578 0%, #C0D392 40%, #D8E2B8 100%' },
  },
  {
    key: 'coral-pink',
    name: '珊瑚粉',
    colors: { primary: '#FFA6A0', primaryLight: '#FFC2BE', primaryDark: '#E87E78', gradient: '135deg, #E87E78 0%, #FFA6A0 40%, #FFC2BE 100%' },
  },
  {
    key: 'wall-green',
    name: '瓦松绿',
    colors: { primary: '#6F9986', primaryLight: '#8FB3A3', primaryDark: '#547D6C', gradient: '135deg, #547D6C 0%, #6F9986 40%, #8FB3A3 100%' },
  },
  {
    key: 'turquoise',
    name: '褐土',
    colors: { primary: '#DA8D6C', primaryLight: '#E8AD96', primaryDark: '#B87254', gradient: '135deg, #B87254 0%, #DA8D6C 40%, #E8AD96 100%' },
  },
]

interface ThemeState {
  current: string
  isDark: boolean
  setTheme: (key: string) => void
  toggleDark: () => void
}

function applyTheme(key: string) {
  document.documentElement.setAttribute('data-theme', key)
  localStorage.setItem('app-theme', key)
}

function applyDarkMode(isDark: boolean) {
  if (isDark) {
    document.documentElement.setAttribute('data-mode', 'dark')
  } else {
    document.documentElement.removeAttribute('data-mode')
  }
  localStorage.setItem('app-dark', isDark ? '1' : '0')
}

function getSavedTheme(): string {
  return localStorage.getItem('app-theme') || 'aurora-sage'
}

function getSavedDarkMode(): boolean {
  return localStorage.getItem('app-dark') === '1'
}

export const useThemeStore = create<ThemeState>()((set) => ({
  current: getSavedTheme(),
  isDark: getSavedDarkMode(),

  setTheme: (key: string) => {
    applyTheme(key)
    set({ current: key })
  },

  toggleDark: () => {
    set((state) => {
      const next = !state.isDark
      applyDarkMode(next)
      return { isDark: next }
    })
  },
}))

/** 启动时应用已保存的主题 */
export function initTheme() {
  applyTheme(getSavedTheme())
  applyDarkMode(getSavedDarkMode())
}
